import { render, staticRenderFns } from "./AvatarImageComponent.vue?vue&type=template&id=70ebfbc2"
import script from "./AvatarImageComponent.vue?vue&type=script&lang=js"
export * from "./AvatarImageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports